import { useTranslation } from 'react-i18next';
import MainTooltip from '../../Tooltips/MainTooltip';
import { colors } from '../../../theme/colors';
import spacing, { isMobileScreen } from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';

const UseYourDeviceInfoTooltip = () => {
  const { t, i18n } = useTranslation();
  return (
    <MainTooltip
      title={
        <div
          style={{
            padding: spacing.xs,
            fontSize: fontSize.md,
            color: colors.textPrimary,
          }}
        >
          {t('location.approximateLocationExplanation')}
        </div>
      }
      tooltipCustomization={{
        placement: 'bottom-start',
      }}
    >
      <div
        style={{
          fontSize: isMobileScreen ? fontSize.md : fontSize.lg,
          fontWeight: 'bold',
          textAlign: 'center',
        }}
      >
        {t('common.learnMore')}
      </div>
    </MainTooltip>
  );
};

export default UseYourDeviceInfoTooltip;
